import { gql } from '@apollo/client'

export const createOrUpdateReadingGoals = gql`
  mutation CreateOrUpdateReadingGoals($goal: Int!, $entityIds: [Int!]!) {
    createOrUpdateReadingGoals(input: { goal: $goal, entityIds: $entityIds }) {
      readingGoals {
        goal
        startDate
        entityId
      }
    }
  }
`

export const deactivateReadingGoal = gql`
  mutation DeactivateReadingGoal($entityId: Int!) {
    deactivateReadingGoal(input: { entityId: $entityId }) {
      readingGoals {
        goal
        startDate
        endDate
        entityId
      }
    }
  }
`

export const getReadingGoalsByEntities = gql`
  query GetReadingGoalsByEntities($entityIds: [Int!]!) {
    readingGoals(entityIds: $entityIds) {
      goal
      startDate
      entityId
    }
  }
`

export const getReadingGoalReport = gql`
  query GetReadingGoalReport(
    $entityId: Int!
    $page: Int!
    $limit: Int!
    $referenceDate: DateTime!
  ) {
    readingGoalsReport(
      entityId: $entityId
      page: $page
      limit: $limit
      referenceDate: $referenceDate
      orderBy: BY_READING_TIME
    ) {
      readingGoal {
        goal
        startDate
      }
      totalCount
      users {
        name
        readingTime
      }
    }
  }
`
